<style scoped lang="scss">
.account-stauts{
  text-align: center;
  min-height: calc(100vh - 428px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  .title{
    font-weight: bold;
    font-size: 30px;
    margin-bottom: 10px;
  }
}
</style>
<template>
  <section class="account-stauts">
    <div v-show="status === 0">
      <img src="@/assets/images/icon_warn.png">
      <div class="title">帐号已冻结</div>
      <p>您因违规操作，帐号已被冻结。如有疑问，请联系工作人员。</p>
    </div>
    <div v-show="status === 1">
      <img src="@/assets/images/icon_warn.png">
      <div class="title">注册流程有误</div>
      <p>如需工作人员再次协助，请重新发起注册。</p>
      <el-button type="primary" class="mt20" @click="$router.push('/register')">重新注册</el-button>
    </div>
    <div v-show="status === 2">
      <img src="@/assets/images/icon_more.png" style="width:100px;">
      <div class="title">审核中</div>
      <p>平台正在审核您的注册资料，请耐心等待。</p>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      status: Number(this.$route.query.status)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/account_status.vue